import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    "model-value": _ctx.open,
    "max-width": "900px",
    scrollable: "",
    persistent: "",
    "onUpdate:modelValue": _ctx.onDialogUpdate
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, { class: "d-flex align-center" }, {
            default: _withCtx(() => [
              _cache[2] || (_cache[2] = _createElementVNode("span", null, "Review Workflow Document", -1)),
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_btn, {
                icon: "mdi-close",
                variant: "text",
                size: "small",
                disabled: _ctx.submitting,
                onClick: _ctx.onDiscard
              }, null, 8, ["disabled", "onClick"])
            ]),
            _: 1,
            __: [2]
          }),
          _createVNode(_component_v_divider),
          _createVNode(_component_v_card_text, { class: "pt-4" }, {
            default: _withCtx(() => [
              (_ctx.errorMessage)
                ? (_openBlock(), _createBlock(_component_v_alert, {
                    key: 0,
                    type: "error",
                    density: "compact",
                    variant: "tonal",
                    class: "mb-4"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.errorMessage), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_v_alert, {
                type: "warning",
                density: "compact",
                variant: "outlined",
                class: "mb-4"
              }, {
                default: _withCtx(() => _cache[3] || (_cache[3] = [
                  _createTextVNode(" Do not refresh the page or navigate away until you send or discard this workflow document. The review draft will be lost if the page reloads. ")
                ])),
                _: 1,
                __: [3]
              }),
              _createVNode(_component_v_textarea, {
                "model-value": _ctx.modelValue,
                label: "Workflow Document",
                variant: "outlined",
                rows: "18",
                "auto-grow": "",
                "hide-details": "",
                "onUpdate:modelValue": _ctx.onModelUpdate
              }, null, 8, ["model-value", "onUpdate:modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_divider),
          _createVNode(_component_v_card_actions, { class: "px-4 py-3" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                variant: "text",
                disabled: _ctx.submitting,
                onClick: _ctx.onDiscard
              }, {
                default: _withCtx(() => _cache[4] || (_cache[4] = [
                  _createTextVNode(" Discard ")
                ])),
                _: 1,
                __: [4]
              }, 8, ["disabled", "onClick"]),
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_btn, {
                color: "secondary",
                variant: "outlined",
                disabled: _ctx.submitting || !_ctx.canSubmitToCurrentChat || !_ctx.hasContent,
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('submit-to-current-chat')))
              }, {
                default: _withCtx(() => _cache[5] || (_cache[5] = [
                  _createTextVNode(" Send To Current Chat ")
                ])),
                _: 1,
                __: [5]
              }, 8, ["disabled"]),
              _createVNode(_component_v_btn, {
                color: "primary",
                loading: _ctx.submitting,
                disabled: _ctx.submitting || !_ctx.hasContent,
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('submit-to-new-chat')))
              }, {
                default: _withCtx(() => _cache[6] || (_cache[6] = [
                  _createTextVNode(" Start New Chat ")
                ])),
                _: 1,
                __: [6]
              }, 8, ["loading", "disabled"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["model-value", "onUpdate:modelValue"]))
}